import _asyncToGenerator from '@babel/runtime/helpers/asyncToGenerator';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import '@kdocs/kdesign-vue/lib/theme-chalk/checkbox.css';
import _Checkbox from '@kdocs/kdesign-vue/lib/checkbox';
import _regeneratorRuntime from '@babel/runtime/regenerator';
import qs from 'qs';
import KButton from '@kso/ui/lib/Button';
import '@kso/ui/lib/Button/style.css';
import KLoading from '@kso/ui/lib/Loading';
import '@kso/ui/lib/Loading/style.css';
import { t } from '@kso/ui/lib/config/locale';
import { isSquareFile, fileReportNew, fileReport, reportComment, publishfileReport, newShareReport, annexReport, activeArticleReport, AiReport } from '@kso/ui/lib/request';
import UA from '@kso/ui/lib/utils/ua';
import errors from '@kso/ui/lib/utils/errors';
import { completionCdn } from '@kso/ui/lib/utils';
import { openBrowser } from '@kso/sdk-super/lib/mdocs';
import { Base64 } from 'js-base64';
import Report$1 from '@wps/ai_common_sdk/dist/plugins/report/report-factory';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Report = {
  render: function render() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c('div', {
      staticClass: "k-report",
      "class": [_vm.from && "k-report--" + _vm.from, _vm.isAIScene && 'k-report--ai']
    }, [_vm.loading && !_vm.uaMobile ? _c('KLoading', {
      staticClass: "k-report__loading"
    }) : !_vm.loading ? [_c('div', {
      staticClass: "k-report__title"
    }, [_vm._v(_vm._s(_vm.compTitle))]), _vm._v(" "), _vm._l(_vm.compReasons, function (reason, index) {
      return _c('div', {
        key: index
      }, [_c('label', {
        staticClass: "k-report__item"
      }, [_c('div', {
        staticClass: "k-report__item-radio"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: _vm.picked,
          expression: "picked"
        }],
        attrs: {
          "type": "radio",
          "disabled": !!_vm.result
        },
        domProps: {
          "value": reason,
          "checked": _vm._q(_vm.picked, reason)
        },
        on: {
          "change": function change($event) {
            _vm.picked = reason;
          }
        }
      }), _vm._v(" "), _c('i')]), _vm._v(" "), _c('div', {
        staticClass: "k-report__item-select"
      }, [_c('span', {
        staticClass: "k-report__item-label"
      }, [_vm._v(_vm._s(reason))])])])]);
    }), _vm._v(" "), _vm.showReportDesc ? [_vm.isMobile ? _c('div', {
      staticClass: "k-report__divide"
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "k-report__title k-report__title_decs k-report__title-reason"
    }, [_vm._v(_vm._s(_vm.lang_txt17))]), _vm._v(" "), _c('div', {
      staticClass: "k-report__comment"
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.comment,
        expression: "comment"
      }],
      ref: "commentRef",
      staticClass: "k-report__textarea",
      "class": {
        disabled: !!_vm.result
      },
      attrs: {
        "placeholder": _vm.lang_txt18,
        "rows": _vm.uaMobile ? 3 : 5
      },
      domProps: {
        "value": _vm.comment
      },
      on: {
        "click": function click($event) {
          $event.stopPropagation();
        },
        "paste": function paste($event) {
          $event.stopPropagation();
        },
        "input": [function ($event) {
          if ($event.target.composing) {
            return;
          }
          _vm.comment = $event.target.value;
        }, _vm.handleInput]
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "k-report__textarea-count"
    }, [_c('span', {
      "class": [_vm.commentSize > _vm.maxCommentSize ? 'k-report__textarea-count-size' : '']
    }, [_vm._v(_vm._s(_vm.commentSize))]), _c('span', {
      staticClass: "k-report__textarea-count-max-size"
    }, [_vm._v("/" + _vm._s(_vm.maxCommentSize)), !_vm.uaMobile ? _c('span', [_vm._v(_vm._s(_vm.lang_words))]) : _vm._e()])])])] : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "k-report__bottom",
      "class": [_vm.isQQMini ? '' : 'k-report__bottom--fix', _vm.result ? 'k-report__bottom--hide' : '', _vm.isAIScene && 'k-report__bottom--ai', _vm.isAIScene && _vm.uaMobile && 'k-report__bottom--mai']
    }, [_vm.isAIScene && !_vm.uaMobile && !_vm.result ? _c('div', {
      staticClass: "k-report_aiAgree"
    }, [_c('kd-checkbox', {
      model: {
        value: _vm.checkedAi,
        callback: function callback($$v) {
          _vm.checkedAi = $$v;
        },
        expression: "checkedAi"
      }
    }, [_vm._v(_vm._s(_vm.lang_txt24))])], 1) : _vm._e(), _vm._v(" "), !_vm.isAIScene && _vm.showReportPhone ? _c('p', {
      staticClass: "k-report__bottom-phone"
    }, [_vm._v(_vm._s(_vm.lang_reportNumber))]) : _vm._e(), _vm._v(" "), _c('KButton', {
      "class": {
        disabled: !!_vm.result
      },
      attrs: {
        "type": "primary",
        "disabled": _vm.disabledStatus,
        "loading": _vm.commitLoading
      },
      on: {
        "click": _vm.onSubmit
      }
    }, [_vm._v(_vm._s(_vm.btnTxt))]), _vm._v(" "), _vm.isAIScene && _vm.uaMobile && !_vm.result ? _c('div', {
      staticClass: "k-report_aiAgree",
      "class": _vm.shakeClass && 'shake'
    }, [_c('kd-checkbox', {
      model: {
        value: _vm.checkedAi,
        callback: function callback($$v) {
          _vm.checkedAi = $$v;
        },
        expression: "checkedAi"
      }
    }, [_vm._v(_vm._s(_vm.lang_txt24))])], 1) : _vm._e()], 1), _vm._v(" "), _vm.result ? _c('div', {
      staticClass: "k-report__result"
    }, [_c('img', {
      attrs: {
        "src": _vm.QN + "/kdocs/cloud/icon/" + _vm.result + ".svg"
      }
    }), _vm._v(" "), _vm.from === 'mobile' ? _c('div', [_c('p', [_vm._v(_vm._s(_vm.result === 'success' ? _vm.lang_txt0 : _vm.lang_txt1))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.result === 'success' ? _vm.name && _vm.params.scene === 'file' ? "" + _vm.lang_txt3 + _vm.name + _vm.lang_txt31 : '' : _vm.lang_txt4))])]) : _c('p', [_vm._v(_vm._s(_vm.result === 'success' ? _vm.lang_txt5 : _vm.errorMsg))])]) : _vm._e()] : _vm._e()], 2);
  },
  staticRenderFns: [],
  name: 'KReport',
  componentName: 'KReport',
  components: _defineProperty(_defineProperty(_defineProperty({}, _Checkbox.name, _Checkbox), "KButton", KButton), "KLoading", KLoading),
  props: {
    // 文件id
    id: {
      type: [Number, String]
    },
    shareid: {
      type: String
    },
    cid: {
      type: String
    },
    // 文件名
    name: {
      type: String,
      "default": ''
    },
    title: {
      type: String,
      "default": ''
    },
    btnTxt: {
      type: String,
      "default": t('logic.Report.public_Report_submit')
    },
    reasons: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    from: {
      type: String,
      "default": ''
    },
    shareFrom: {
      // 'newShare'表示为新分享
      type: String,
      "default": ''
    },
    expandScene: {
      // 拓展渠道，特殊处理，新增aiReport/mobile走弹窗 && 反馈内容调整
      type: String,
      "default": ''
    },
    // AI举报参数
    messageId: {
      type: [Number, String]
    },
    officeType: {
      type: String,
      "default": ''
    },
    source: {
      // 组件类型
      type: String,
      "default": ''
    },
    scene: {
      // 举报场景
      type: String,
      "default": ''
    },
    aiCommit: {
      // 举报详细描述
      type: String,
      "default": ''
    },
    content: {
      type: String,
      "default": ''
    },
    reportApiType: {
      type: String,
      "default": ''
    },
    reportType: {
      type: Number,
      "default": 0
    }
    // AI举报参数 end
  },
  data: function data() {
    return {
      lang_txt0: t('logic.Report.txt0'),
      lang_txt1: t('logic.Report.txt1'),
      lang_txt2: t('logic.Report.txt2'),
      lang_txt3: t('logic.Report.txt3'),
      lang_txt31: t('logic.Report.txt31'),
      lang_txt4: t('logic.Report.txt4'),
      lang_txt5: t('logic.Report.txt5'),
      lang_txt6: t('logic.Report.txt6'),
      lang_txt24: t('logic.Report.text24'),
      lang_txtWarn: t('logic.Report.txt13'),
      lang_words: t('logic.Report.txt20'),
      lang_reportNumber: t('logic.Report.txt21'),
      lang_txtWarnExtra: {
        txt: t('logic.Report.txt14'),
        link: 'http://www.gdjubao.cn/jb/?harm_type=18'
      },
      isQQMini: false,
      result: '',
      picked: '',
      UA: UA,
      QN: completionCdn(),
      errorMsg: '',
      // 具体失败原因
      lang_txt17: t('logic.Report.txt17'),
      lang_txt18: t('logic.Report.txt18'),
      comment: '',
      // 举报说明
      maxCommentSize: 200,
      // 评论最大字数
      minCommentSize: 5,
      // 评论最小字数
      isSquareFileResult: false,
      // 是否为广场文档
      isSubFileResult: false,
      // 是否为附件文档
      isShareResult: false,
      // 是否为发布场景
      isCommentResult: false,
      // 是否为广场帖子评论
      loading: true,
      // 加载中
      checkedAi: false,
      // 勾选ai协议
      commitLoading: false,
      // 提交按钮loading
      shakeClass: false // 抖动效果
    };
  },
  computed: {
    isAIScene: function isAIScene() {
      return this.expandScene === 'aiReport';
    },
    uaMobile: function uaMobile() {
      return UA.isMobile;
    },
    isMobile: function isMobile() {
      if (this.isAIScene) {
        return false;
      }
      return UA.isMobile && !UA.isTablet && !UA.isiPad;
    },
    showReportPhone: function showReportPhone() {
      var _this = this;
      // 仅举报未成年 && 小程序端 && 移动端
      var _minors = this.compReasons.find(function (i) {
        return i === _this.lang_txtWarn;
      });
      return !!_minors && UA.miniprogram && this.from === 'mobile';
    },
    showTitle: function showTitle() {
      var searchParams = this.getSearchParams();
      return searchParams['pageTitle'] || this.title;
    },
    params: function params() {
      var searchParams = this.getSearchParams();
      var params = {
        scene: 'file'
      };
      if (searchParams['params']) {
        params = JSON.parse(Base64.decode(decodeURI(searchParams['params'])));
      }
      return params;
    },
    commentTrim: function commentTrim() {
      return this.comment.trim();
    },
    commentSize: function commentSize() {
      return this.commentTrim.length;
    },
    commentError: function commentError() {
      return this.showReportDesc && (this.commentSize > this.maxCommentSize || this.commentSize < this.minCommentSize);
    },
    compReasons: function compReasons() {
      if (this.reasons && this.reasons.length) {
        return this.reasons;
      } else {
        return this.showReportDesc ? [t('logic.Report.label10'), t('logic.Report.label40'), t('logic.Report.label20'), t('logic.Report.txt13')] : [t('logic.Report.txt8'), t('logic.Report.txt9'), t('logic.Report.txt10'), t('logic.Report.txt11'), t('logic.Report.txt12'), t('logic.Report.txt13')];
      }
    },
    showReportDesc: function showReportDesc() {
      // 是否显示举报描述字段
      return !(this.isSquareFileResult || this.isSubFileResult || this.isCommentResult || this.isAIScene);
    },
    compTitle: function compTitle() {
      if (this.isAIScene) {
        return t('logic.Report.text23');
      }
      var txt = this.params.scene === 'file' ? t('logic.Report.txt7') : t('logic.Report.txt22');
      return this.showTitle || txt + (this.showReportDesc ? t('logic.Report.txt19') : '');
    },
    isNewShareReport: function isNewShareReport() {
      // 是否为新分享场景
      return this.shareFrom === 'newShare';
    },
    disabledStatus: function disabledStatus() {
      if (this.isAIScene && this.uaMobile) {
        return !this.picked;
      }
      if (this.isAIScene) {
        return !this.checkedAi || !this.picked;
      }
      return !this.picked || this.commentError;
    }
  },
  mounted: function mounted() {
    var _this2 = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var ua, searchParams, subFileId;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            ua = navigator.userAgent;
            _this2.isQQMini = /QQ/i.test(ua) && / miniProgram/i.test(ua);
            _this2.loading = true;
            // 判断属于哪种举报类型
            if (!_this2.cid) {
              _context.next = 12;
              break;
            }
            _context.prev = 4;
            _context.next = 7;
            return isSquareFile(_this2.cid);
          case 7:
            _this2.isSquareFileResult = _context.sent;
            _context.next = 12;
            break;
          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](4);
          case 12:
            searchParams = _this2.getSearchParams();
            subFileId = searchParams && searchParams['sub_file_id']; // 附件id
            console.log('subFileId: ', subFileId);
            console.log(searchParams && searchParams['attachment_pid'], window.top.fileInfo && window.top.fileInfo.attachment_pid);
            if (subFileId) {
              // 判断文件是不是一个附件
              _this2.isSubFileResult = true;
            } else {
              if (_this2.shareid) {
                // 是否发布场景举报
                _this2.isShareResult = true;
              }
            }
            _this2.isCommentResult = searchParams && searchParams['commentId']; // 广场帖子评论

            _this2.loading = false;
          case 19:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[4, 10]]);
    }))();
  },
  methods: {
    getSearchParams: function getSearchParams() {
      // 获取url上的参数
      var search = window.top.location.search;
      var searchParams = qs.parse(search, {
        ignoreQueryPrefix: true
      });
      return searchParams;
    },
    onSubmit: function onSubmit(reason, _extral) {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var searchParams, subFileId, attachmentPid, fileReportResons, isPublishFile, _ref, _ref$label, label, _ref2, _ref2$tag, tag, shareParams, _ref3, _ref3$label, _label, _e$response;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this3.$nextTick();
            case 2:
              if (!(_this3.isAIScene && _this3.uaMobile && _this3.checkedAi === false)) {
                _context2.next = 6;
                break;
              }
              // 未勾选添加抖动效果
              _this3.shakeClass = true;
              setTimeout(function () {
                _this3.shakeClass = false;
              }, 500);
              return _context2.abrupt("return");
            case 6:
              _this3.commitLoading = true;
              if (!(UA.wxpcmini && _extral)) {
                _context2.next = 11;
                break;
              }
              // pc小程序端屏蔽外链
              _this3.$emit('change', 'KExternalLinkTip', {
                url: _extral.link,
                backprev: true
              });
              _context2.next = 18;
              break;
            case 11:
              if (!_extral) {
                _context2.next = 18;
                break;
              }
              if (!(UA.mdocs && !UA.isAndroid)) {
                _context2.next = 17;
                break;
              }
              _context2.next = 15;
              return openBrowser({
                url: _extral.link
              })["catch"](function (err) {
                return err;
              });
            case 15:
              _context2.next = 18;
              break;
            case 17:
              window && window.open(_extral.link, '_blank');
            case 18:
              _context2.prev = 18;
              if (!_this3.isSquareFileResult) {
                _context2.next = 22;
                break;
              }
              _context2.next = 22;
              return activeArticleReport({
                fid: _this3.id,
                reasonDetail: reason || _this3.picked
              });
            case 22:
              _context2.next = 27;
              break;
            case 24:
              _context2.prev = 24;
              _context2.t0 = _context2["catch"](18);
              console.log(_context2.t0);
            case 27:
              _context2.prev = 27;
              searchParams = _this3.getSearchParams();
              if (!_this3.isSubFileResult) {
                _context2.next = 36;
                break;
              }
              // 判断文件是不是一个附件
              subFileId = searchParams && searchParams['sub_file_id']; // 附件id
              attachmentPid = searchParams && searchParams['attachment_pid'] || window.top.fileInfo && window.top.fileInfo.attachment_pid;
              _context2.next = 34;
              return annexReport({
                id: attachmentPid || 0,
                // 父文档id (pc上取window.top.fileInfo.attachment_pid， 移动端上取attachment_pid)
                params: {
                  kind: 0,
                  // 申述类型，0: 被举报; 1：申述
                  attachment_id: subFileId || 0 // 附件id
                }
              });
            case 34:
              _context2.next = 74;
              break;
            case 36:
              fileReportResons = [{
                label: 'Politics',
                tag: '10',
                txt: t('logic.Report.label10')
              }, {
                label: 'Illegal',
                tag: '40',
                txt: t('logic.Report.label40')
              }, {
                label: 'Porn',
                tag: '20',
                txt: t('logic.Report.label20')
              }, {
                label: 'Nonage',
                tag: '60',
                txt: t('logic.Report.txt13')
              }];
              isPublishFile = !!searchParams.publishId;
              if (!isPublishFile) {
                _context2.next = 44;
                break;
              }
              // 查询label
              _ref = fileReportResons.find(function (item) {
                return item.txt === (reason || _this3.picked);
              }) || {}, _ref$label = _ref.label, label = _ref$label === void 0 ? '' : _ref$label;
              _context2.next = 42;
              return fileReportNew(searchParams.originId, _objectSpread(_objectSpread({}, _this3.params), {}, {
                label: label,
                comment: _this3.commentTrim,
                pub_id: searchParams.publishId,
                version: Number(searchParams.version)
              }));
            case 42:
              _context2.next = 74;
              break;
            case 44:
              if (!_this3.isAIScene) {
                _context2.next = 49;
                break;
              }
              _context2.next = 47;
              return _this3.callAiReport(reason);
            case 47:
              _context2.next = 74;
              break;
            case 49:
              if (!_this3.isShareResult) {
                _context2.next = 61;
                break;
              }
              // 查询label
              _ref2 = fileReportResons.find(function (item) {
                return item.txt === (reason || _this3.picked);
              }) || {}, _ref2$tag = _ref2.tag, tag = _ref2$tag === void 0 ? '' : _ref2$tag;
              shareParams = {
                share_id: _this3.shareid,
                reason: _this3.commentTrim,
                label: tag
              };
              if (!_this3.isNewShareReport) {
                _context2.next = 57;
                break;
              }
              _context2.next = 55;
              return newShareReport(shareParams);
            case 55:
              _context2.next = 59;
              break;
            case 57:
              _context2.next = 59;
              return publishfileReport(shareParams);
            case 59:
              _context2.next = 74;
              break;
            case 61:
              if (!_this3.isCommentResult) {
                _context2.next = 66;
                break;
              }
              _context2.next = 64;
              return reportComment({
                commentId: searchParams && searchParams['commentId'] && Number(searchParams['commentId']),
                reasonDetail: reason || _this3.picked
              });
            case 64:
              _context2.next = 74;
              break;
            case 66:
              if (!(_this3.isSquareFileResult || !_this3.cid)) {
                _context2.next = 71;
                break;
              }
              _context2.next = 69;
              return fileReport({
                fileid: _this3.id,
                reason_detail: reason || _this3.picked
              });
            case 69:
              _context2.next = 74;
              break;
            case 71:
              // 查询label
              _ref3 = fileReportResons.find(function (item) {
                return item.txt === (reason || _this3.picked);
              }) || {}, _ref3$label = _ref3.label, _label = _ref3$label === void 0 ? '' : _ref3$label;
              _context2.next = 74;
              return fileReportNew(_this3.cid, _objectSpread(_objectSpread({}, _this3.params), {}, {
                label: _label,
                comment: _this3.commentTrim
              }));
            case 74:
              _this3.$emit('commit', reason || _this3.picked);
              if (!reason) {
                _this3.result = 'success';
                _this3.$emit('success', _this3.picked);
              }
              _context2.next = 81;
              break;
            case 78:
              _context2.prev = 78;
              _context2.t1 = _context2["catch"](27);
              if (!reason) {
                _this3.result = 'fail';
                _this3.errorMsg = errors[_context2.t1 === null || _context2.t1 === void 0 || (_e$response = _context2.t1.response) === null || _e$response === void 0 || (_e$response = _e$response.data) === null || _e$response === void 0 ? void 0 : _e$response.result] || _this3.lang_txt6;
                _this3.$emit('fail', _context2.t1);
              }
            case 81:
              _this3.commitLoading = false;
            case 82:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[18, 24], [27, 78]]);
      }))();
    },
    callAiReport: function callAiReport(reason) {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var idx, mapsLabel, data;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              idx = _this4.compReasons.indexOf(reason || _this4.picked);
              mapsLabel = {
                0: '10',
                1: '40',
                2: '20',
                3: '60'
              };
              data = {
                label: mapsLabel[idx]
              };
              _this4.scene && (data.scene = _this4.scene);
              _this4.aiCommit && (data.comment = _this4.aiCommit);
              _this4.content && (data.content = _this4.content);
              if (!(_this4.reportApiType === 'getReportWarnV5')) {
                _context3.next = 13;
                break;
              }
              data.report_id = _this4.messageId;
              data.report_type = _this4.reportType;
              _context3.next = 11;
              return Report$1.getReportWarnV5({
                params: data
              });
            case 11:
              _context3.next = 16;
              break;
            case 13:
              data.message_id = _this4.messageId;
              _context3.next = 16;
              return AiReport(data, {
                source: _this4.source
              });
            case 16:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    handleInput: function handleInput() {
      // 滚动条占用宽度适配【overflow: overlay】
      var el = this.$refs.commentRef;
      if (el && this.from !== 'mobile') {
        this.$nextTick(function () {
          if (el.scrollHeight > el.clientHeight) {
            el.style.paddingRight = 0;
          } else {
            el.style.paddingRight = '10px';
          }
        });
      }
    }
  }
};

Report.install = function (Vue) {
  Vue.component(Report.name, Report);
};

export { Report as default };
